<!-- leading # icon: the tag area reads as one segment [# chips input] -->
<i class="input-multi-level-icon icon-hashtag" aria-hidden="true"></i>

<ul class="input-chips" role="list" [attr.aria-label]="'tagsEditor.listLabel' | translate">
  @for (item of selected(); track item.id) {
    @if (!this.edition() || item.id !== this.edition().id) {
      <li
        #chip
        class="input-chip"
        role="listitem"
        [class.input-chip-selected]="pendingRemovalId() === item.id"
        [title]="item.name + ': ' + (item?.displayValue ?? item.value)">
        <i class="input-chip-prefix icon-hashtag" aria-hidden="true"></i>
        <span class="input-chip-text" (click)="onEdit($event, item)">
          {{ item.name }}: {{ item?.displayValue ?? item.value }}
        </span>
        @if (!disabled()) {
          <button
            class="input-chip-btn"
            type="button"
            [attr.aria-label]="'tagsEditor.removeTag' | translate: { tag: item.name + ': ' + (item?.displayValue ?? item.value) }"
            (click)="onRemove($event, item)">
            <i class="icon-cross" aria-hidden="true"></i>
          </button>
        }
      </li>
    } @else {
      <li #chip class="input-chip input-chip-editor">
        <ng-container
          [ngTemplateOutlet]="editing"
          [ngTemplateOutletContext]="{
            groupName: editionGroup()?.groupName,
            items: editionActiveItems(),
            fct: updateValue.bind(this),
            blurEvent: true,
          }" />
      </li>
    }
  }

  @if (disabled() && !selected()?.length) {
    <li class="input-chips-empty">-</li>
  }

  @if (!edition() && !disabled()) {
    <li class="input-wrapper" [ngClass]="{ 'input-filled': activeGroupName()?.length > 0 }">
      @if (activeGroupName()) {
        <ng-container
          [ngTemplateOutlet]="editing"
          [ngTemplateOutletContext]="{
            groupName: activeGroupName(),
            items: activeItems(),
            fct: addValue.bind(this),
            blurEvent: true,
          }" />
      } @else {
        <ng-container
          [ngTemplateOutlet]="input"
          [ngTemplateOutletContext]="{
            items: groupFiltered(),
            placeholder: groupFiltered()?.length > 0 ? placeholder() : '',
            fct: addGroupNameValue.bind(this),
            blurEvent: false,
          }" />
      }
    </li>
  }
</ul>

<ng-template #editing let-groupName="groupName" let-items="items" let-fct="fct" let-blurEvent="blurEvent">
  <span> {{ groupName }}: </span>
  <ng-container
    [ngTemplateOutlet]="input"
    [ngTemplateOutletContext]="{
      items: items,
      placeholder: undefined,
      fct: fct,
      blurEvent: blurEvent,
    }" />
</ng-template>

<ng-template #input let-items="items" let-placeholder="placeholder" let-fct="fct" let-blurEvent="blurEvent">
  <iu-autocomplete-ui
    #autocomplete
    [cssClass]="'multi-level-autocomplete-input p-col-12 p-md-6 p-lg-4'"
    label=""
    [data]="{ items: items }"
    [fieldValue]="fieldValue"
    (fieldValueModified)="fct($event)"
    (blurEmitter)="pendingRemovalId.set(undefined); blurEvent && !edition() ? removeItemIfEmpty() : reverseEdition()"
    (keydown)="removeItemOnBackspace($event)"
    [placeholder]="placeholder"
    [isStandalone]="true"
    [styleLess]="true" />
</ng-template>
